import React from "react";
import { Facebook, WhatsApp, Telegram, Instagram, Share } from "@mui/icons-material";

type SharingLinksProps = {
  projectId: number;
  projectName: string;
  projectDescription: string;
};

const SharingLinks: React.FC<SharingLinksProps> = ({ projectId, projectName, projectDescription }) => {
  const projectUrl = `${window.location.origin}/projects/${projectId}`;

  const sharingLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(projectUrl)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(projectUrl)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(projectUrl)}&text=${encodeURIComponent(projectName)}`,
    instagram: "https://www.instagram.com", // Instagram doesn't support direct sharing via URL.
  };

  const handleNativeShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: projectName,
          text: projectDescription,
          url: projectUrl,
        })
        .catch(console.error);
    } else {
      alert("المشاركة غير مدعومة في هذا المتصفح.");
    }
  };

  return (
    <div className="mt-8 p-4 border-2 border-black">
      <h2 className="text-center text-xl font-bold mb-6">يمكنك مشاركة المشروع ايضا</h2>
      <div className="grid grid-cols-5 max-sm:grid-cols-2 gap-4">
        <a href={sharingLinks.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-700 flex gap-2 items-center">
          <Facebook fontSize="large" />
          <span className="text-sm">Facebook</span>
        </a>
        <a href={sharingLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="text-green-500 flex gap-2 items-center">
          <WhatsApp fontSize="large" />
          <span className="text-sm">WhatsApp</span>
        </a>
        <a href={sharingLinks.telegram} target="_blank" rel="noopener noreferrer" className="text-blue-600 flex gap-2 items-center">
          <Telegram fontSize="large" />
          <span className="text-sm">Telegram</span>
        </a>
        <a href={sharingLinks.instagram} target="_blank" rel="noopener noreferrer" className="text-pink-600 flex gap-2 items-center">
          <Instagram fontSize="large" />
          <span className="text-sm">Instagram</span>
        </a>
        <button onClick={handleNativeShare} className="text-gray-600 flex gap-2 items-center">
          <Share fontSize="large" />
          <span className="text-sm">مشاركة</span>
        </button>
      </div>
    </div>
  );
};

export default SharingLinks;
